<template>
  <div class="client-bill">
    <div>
      <center>
        <img
          height="150"
          style="max-width: 200px; max-height: 150px"
          :src="appLogo"
        />
        <hr />
        <p class="title">
          <b>ACTE DE DEPOT</b>
        </p>
      </center>
      <p align="right">Tunis le {{ date() }}</p>
      <p>
        Je soussignée {{ clientName }} Titulaire de la CIN n° : . . . . . . . .
        . . Tel : {{ clientPhoneNumber }}
        déclare avoir déposé auprès de
        {{ simplePlateformName.toUpperCase() }} le(s) article(s) décrit(s)
        Ci-après :
      </p>
      <ul>
        <li v-for="(product, index) in products" :key="index">
          {{ product.name }}
          <span v-if="isPriceIncluded">| Prix : {{ product.price }} DT</span>
        </li>
      </ul>
      <p>
        J'atteste par le présent document que les produits sus-indiqués
        m’appartiennent (non volés et non empruntés) et qu'ils ne sont pas issus
        de la contrefaçon. A défaut, je prends entièrement la responsabilité que
        ce soit auprès de {{ simplePlateformName.toUpperCase() }} ou auprès des
        tiers.
        <br />
        <br />Par le présent acte, j’autorise
        {{ simplePlateformName.toUpperCase() }} à vendre le(s) bien(s) ci-dessus
        au(x) prix indiqué(s) et à percevoir une commission convenue de
        {{ defaultPercentageText }}% qui en sera déduite. Cet engagement est
        valable pendant une période de dépôt de
        {{ defaultValidity }} jours.<br />Durant cette période, si je souhaite
        mettre fin au présent engagement en récupérant un ou plusieurs ou la
        totalité des articles déposés, je reconnais devoir au préalable
        indemniser {{ simplePlateformName.toUpperCase() }} en lui versant le
        montant des commissions qui auraient été perçues par la vente de cet
        (ces) article(s).
        <br />
        <br />Aussi, je déclare bénéficier d'un délai de 15 jours, à compter de
        la fin de la période de dépôt, pour récupérer les articles qui n'ont pas
        été vendus.
        <br />
        Passé ce délai, je désengage {{ simplePlateformName.toUpperCase() }} de
        toute responsabilité et je reconnais perdre tout droit sur les biens non
        repris.<br />Tout article déposé et non récupéré à temps fera
        automatiquement l'objet de don auprès d’associations à but non lucratif.
        <br />
        <br />
        Le prix des articles sera réduit de 50%, 35 jours après la date du
        dépôt.
        <br />
        <br />
        N.B: {{ simplePlateformName.toUpperCase() }} se réserve le droit de
        retirer sans préavis un article de la vente en cas de défaut non signalé
        lors du dépôt. Les articles déposés ne font pas tous l’objet d’une
        diffusion sur les réseaux sociaux.
      </p>
      <br />
    </div>
    <div style="display: flex; flex-flow: row wrap">
      <p style="width: 30%" align="center">
        <span>CACHET DU DÉPOSITAIRE,</span><br />
        <b>
          <u>{{ simplePlateformName.toUpperCase() }}</u>
        </b>
      </p>
      <p style="width: 40%"></p>
      <p style="width: 30%" align="center">
        <span>SIGNATURE, “Bon pour accord”</span><br />
        <u style="text-transform: uppercase">
          <b>Le déposant</b>
        </u>
      </p>
    </div>
    <br /><br /><br /><br /><br />
    <center>
      <b
        >Le déposant peut suivre la vente de ses articles via le lien suivant
        :</b
      >
    </center>
    <br />
    <div>
      <center>
        <qrcode-vue
          :value="dashboard + (clientId + '')"
          :size="100"
          level="H"
        ></qrcode-vue>
        <a :href="dashboard + (clientId + '')">{{
          dashboard + (clientId + "")
        }}</a>
      </center>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
import constants from "@/mixins/constants";
export default {
  components: {
    QrcodeVue,
  },
  mixins: [constants],
  props: {
    clientName: {
      type: String,
      default: "",
    },
    products: {
      type: Array,
      default: () => {
        return [];
      },
    },
    clientId: {
      type: Number,
      default: 0,
    },
    clientPhoneNumber: {
      type: String,
      default: "",
    },
  },
  computed: {
    dashboard() {
      return `https://mes.${this.appTechName}.tn/myspace/`;
    },
  },
  methods: {
    date: function () {
      const date = new Date();
      const month = date.getMonth() + 1;
      const dayOfMonth = date.getDate();
      const year = date.getFullYear();
      return (
        (dayOfMonth < 10 ? "0" + dayOfMonth : dayOfMonth) +
        "/" +
        (month < 10 ? "0" + month : month) +
        "/" +
        year
      );
    },
  },
};
</script>
<style lang="scss">
.client-bill {
  width: 80%;
  * {
    box-sizing: border-box;
    font-size: 15px;
    color: #000;
  }
  hr {
    margin: 0px;
    margin-top: 5px;
    // border-top: 2px solid rgba(0, 0, 0, 0.1);
  }
  .title {
    font-size: 20px;
    font-weight: bold;
    color: #000;
  }
  .qr-code {
    display: flex;
    flex-flow: column wrap;
    justify-content: center;
    align-items: center;
    padding: 5px;
  }
}
</style>
